"use client";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerDashboard: {
    latestUsage: 0,
    estimateUsage: 0,
    minimumContract: 0,
    maximumContract: 0,
    percentage: 0,
    unit: "MMBtu",
    usageType: "",
    error: "",
    measureStartDate: '',
    measureEndDate: ''
  },
  processMonitoringDashboard: [],
  dailyChartDashboard: {

  },
  monthlyChartDashboard: {

  }
}

export const dashboardSlice = createSlice(
  {
    name: "dashboardSlice",
    initialState,
    reducers: {
      updateCustomerDashboard: (state, action) => {
        state.customerDashboard = action.payload;
      },
      updateProcessMonitoringDashboard: (state, action) => {
        state.processMonitoringDashboard = action.payload;
      },
      updateDailyChartDashboard: (state, action) => {
        state.dailyChartDashboard = action.payload;
      },
      updateMonthlyChartDashboard: (state, action) => {
        state.monthlyChartDashboard = action.payload;
      }
    }
  }
);

export const { updateCustomerDashboard, updateProcessMonitoringDashboard, updateDailyChartDashboard, updateMonthlyChartDashboard } = dashboardSlice.actions;

export default dashboardSlice.reducer;